import { render } from "./VUEAnteprimaColoreSpessore.vue?vue&type=template&id=129a8201"
import script from "./VUEAnteprimaColoreSpessore.vue?vue&type=script&lang=js"
export * from "./VUEAnteprimaColoreSpessore.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__